export const REPORTS_GET = 'REPORTS_GET'
export const REPORTS_DOWNLOAD = 'REPORTS_DOWNLOAD'
export const DELETE_REPORT = 'DELETE_REPORT'